import axios from '@/lib/axios';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

export interface CleanerReviewById {
  id: string;
  comments: string;
  rating: number;
  customer_firstname: string;
  review_date: string | null;
}

export interface CleanerReviewsByIdResponse {
  reviews: CleanerReviewById[];
  total_count: number;
  page: number;
  limit: number;
  total_pages: number;
}

export const cleanerReviewsByIdQueryKey = (cleanerId: string, page?: number) =>
  ['cleaner', 'reviews', cleanerId, { page }] as const;

export async function getCleanerReviewsByIdQuery(
  cleanerId: string,
  page = 1,
  limit = 10
): Promise<CleanerReviewsByIdResponse> {
  const params = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
  });
  const response = await axios.get(
    `/user/details/${cleanerId}/reviews/?${params.toString()}`
  );
  return response.data;
}

export function useGetCleanerReviewsByIdQuery(
  cleanerId: string,
  options?: Partial<UseQueryOptions<CleanerReviewsByIdResponse>>
) {
  return useQuery({
    queryKey: cleanerReviewsByIdQueryKey(cleanerId),
    queryFn: () => getCleanerReviewsByIdQuery(cleanerId),
    retry: false,
    enabled: !!cleanerId && cleanerId.trim().length > 0,
    staleTime: 5 * 60 * 1000,
    ...options,
  });
}
